import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EventItem } from './types'
import type { EventsState } from '../types'

const noEventsConfig = {
  isVisible: false,
  events: [],
}

const initialState: EventsState = { ...noEventsConfig }

export const eventsSlice = createSlice({
  name: 'Events',
  initialState,
  reducers: {
    toggleVisible: (state, action: PayloadAction<boolean>) => {
      state.isVisible = action.payload
    },
    addEvent: (state, action: PayloadAction<Partial<EventItem>>) => {
      const existingEvent = state.events.find((event) => event.eventId === action.payload.eventId)
      if (existingEvent) {
        const updatedEvents = state.events.map((event) => {
          if (event.eventId === existingEvent.eventId) {
            return {
              ...event,
              ...action.payload,
            }
          }
          return event
        })
        state.events = updatedEvents
      } else {
        const newEvents = [...state.events, action.payload]
        state.events = newEvents
      }
    },
  },
})

export const toggleEventDrawer = (visible) => (dispatch) => {
  dispatch(toggleVisible(visible))
}

export const receiveEvent = (event: Partial<EventItem>) => (dispatch) => {
  dispatch(addEvent(event))
}

// Actions
export const { toggleVisible, addEvent } = eventsSlice.actions

export default eventsSlice.reducer
